import { useEffect, useState } from 'react';
import {useGetLoginQuery} from '../redux/loginApi';
import { accessLevels } from '../utils/auth';

export default function useAccessLevel(levelName){
    const { data: user, error: userError, isLoading: userIsLoading } = useGetLoginQuery(); 
    const [allowed, setAllowed] = useState(false);

    useEffect(()=>{
        if(userError){
            setAllowed(false);
        }else{
            const userLevel = user && user.accessLevel;
            const requiredLevel = accessLevels[levelName]
    
            const allowed = (userLevel >= requiredLevel);
            setAllowed(allowed);    
        }
    },[user, userError]);

    return allowed;
}